import type { SVGProps } from 'react';

const SvgNotification = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M13.45 4.85c.03-.11.05-.23.05-.35 0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5c0 .12.02.23.04.34-1.54.28-2.96 1-4.11 2.12A7.92 7.92 0 0 0 4 12.7v3.29c0 1.65 1.35 3 3 3h3c0 1.1.9 2 2 2s2-.9 2-2h3c1.65 0 3-1.35 3-3v-3c0-4.01-2.84-7.43-6.55-8.15zM18 16c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-3.29c0-1.64.65-3.17 1.82-4.31A5.94 5.94 0 0 1 12 6.71h.19C15.4 6.81 18 9.63 18 13z"
    />
    <path
      fill="currentcolor"
      d="M12 9c-2.21 0-4 1.79-4 4 0 .55.45 1 1 1s1-.45 1-1c0-1.1.9-2 2-2 .55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default SvgNotification;
